




































































import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState } from "vuex";

// Model
import { getLicenseModuleLabel, defaultLicenseModuleEnumSorting, LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { getLicenseModuleIconColor } from "@/utility/Constants";

export default Vue.extend({
    data() {
        return {
            LicenseModuleEnum,
        };
    },
    computed: {
        ...mapState({
            installations: (state: RootState) => state.license.installations,
            localInstallations: (state: RootState) => state.license.localInstallations,
        }),

        titles() {
            return [this.$t("licensesManagement.oldModules"), this.$t("licensesManagement.newModules")];
        },

        headers() {
            var headers = [];

            headers.push({ text: this.$t("common.installationName"), value: "name" });
            this.defaultLicenseModuleEnumSorting().forEach((moduleEnumValue) => {
                headers.push({
                    value: LicenseModuleEnum[moduleEnumValue],
                    sortable: false,
                    align: "center",
                });
            });
            headers.push({ text: "", value: "divider", sortable: false, width: "1px" });
            headers.push({ text: this.$t("common.installationName"), value: "localName" });
            this.defaultLicenseModuleEnumSorting().forEach((moduleEnumValue) => {
                headers.push({
                    value: "local" + LicenseModuleEnum[moduleEnumValue],
                    sortable: false,
                    align: "center",
                });
            });

            return headers;
        },

        items() {
            var res = [];
            if (this.installations != null && this.installations.length > 0 && this.localInstallations != null && this.localInstallations.length > 0) {
                this.installations.forEach((installation) => {
                    var currentLocalInstallation = this.localInstallations.filter((i) => i.name == installation.name)[0];
                    if (currentLocalInstallation.licenseData.enabledModules != installation.licenseData.enabledModules)
                        res.push({
                            ...installation,
                            localName: currentLocalInstallation.name,
                            localLicenseData: { enabledModules: currentLocalInstallation.licenseData.enabledModules },
                        });
                });
            }
            return res;
        },
    },
    methods: {
        defaultLicenseModuleEnumSorting,
        getLicenseModuleIconColor,
        getLicenseModuleLabel,

        getHeader(licenseModule, id) {
            return id >= this.defaultLicenseModuleEnumSorting().length ? "local" + LicenseModuleEnum[licenseModule] : LicenseModuleEnum[licenseModule];
        },

        getCheckBoxValue(licenseModule, id, item) {
            return ((id >= defaultLicenseModuleEnumSorting().length ? item.localLicenseData.enabledModules : item.licenseData.enabledModules) & licenseModule) == licenseModule;
        },
    },
});
